// removed by extract-text-webpack-plugin
module.exports = {"upload-modal":"magazines_U04Gr","upload-modal__title":"magazines_2VJeu","upload-modal__input-wrapper":"magazines_3Bnz7","upload-modal__input-wrapper__input":"magazines_32H8x","upload-modal__images-header":"magazines_2zsdR","upload-modal__images-wrapper":"magazines_380ab","upload-modal__images-wrapper__item":"magazines_37tDg","upload-modal__images-wrapper__item__vertical-line":"magazines_3GdqE","upload-modal__image-thumb":"magazines_2ZI2Y","upload-modal__image-text":"magazines_Fe6c0","upload-modal__cancel-button":"magazines_1rDT4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fileManager/FileManagerComponent.scss
// module id = 617
// module chunks = 1